import { createFileRoute } from "@tanstack/react-router";
import IsMyChildDepressed from "@/pages/articles/IsMyChildDepressed";
export const Route = createFileRoute(
  "/is-my-child-depressed-what-parents-should-know",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Is My Child Depressed What Parents Should Know | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Signs of depression in children and teens, what parents should watch for, and when to seek help. Treatment guidance from Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Is My Child Depressed What Parents Should Know | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Signs of depression in children and teens, what parents should watch for, and when to seek help. Treatment guidance from Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/is-my-child-depressed-what-parents-should-know",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/is-my-child-depressed-what-parents-should-know",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IsMyChildDepressed />;
}
